<span  *ngIf="contractTerm;else dash">{{contractTerm }}</span>
<ng-template #dash>-</ng-template>

